var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgToastClose = function SvgToastClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1096 79c-5.52725 0-10 4.47075-10 10 0 5.52725 4.47275 10 10 10 5.52925 0 10-4.47275 10-10 0-5.53025-4.46975-10-10-10zm-3.8125 5.75c.01855-.0009765.03613-.0009765.05469 0 .13476-.0009765.26465.0517575.35937.1484375l3.3985 3.3905 3.3905-3.3905c.09082-.0927725.21387-.1455075.34375-.1484375.20703-.008789.39845.112305.4795.302725.08203.191405.03711.4121-.1123.55665l-3.3985 3.3985 3.3985 3.3905c.09472.09375.14746.22168.14746.355475 0 .1328125-.05274.26075-.14746.355475-.09375.09375-.22168.14746-.35548.14746-.13379 0-.26075-.05371-.35547-.14746l-3.3905-3.3985-3.3985 3.3985c-.19629.19629-.51465.19629-.71095 0s-.19629-.51465 0-.71095l3.3905-3.3905-3.3905-3.3985c-.14161-.1357425-.19141-.340825-.12696-.5254.06348-.18457.2295-.315425.42383-.333975z",
    fill: "#e2e7ee",
    opacity: 0.9,
    transform: "translate(-1086 -79)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgToastClose, _extends({
    svgRef: ref
  }, props));
});
export default "https://static.im-cdn.com/mjc/storefront/Anchor/static/media/ToastClose.826d277a.svg";
export { ForwardRef as ReactComponent };